<template>
  <div class="text"> 
    <div id="breadcrumb">Dürrenmatt Stoffe /<br /><strong>Text {{getVolume}}</strong></div>
    <div class="nav-header" id="textHeader">
        <div class="arrow-box" v-show="$store.state.showBookArrowNavBox">        
            <span class="arrow text-prev" @click="goToPreviousText()">←</span>
            <span class="page-prev" @click="goToPreviousPage()">
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 240.8 240.8" style="enable-background:new 0 0 240.8 240.8;" xml:space="preserve"><path id="Chevron_Left" d="M57.6,129l108.3,108.3c4.8,4.7,12.5,4.7,17.2,0c4.8-4.8,4.8-12.5,0-17.2l-99.7-99.7l99.7-99.7
                c4.8-4.7,4.8-12.4,0-17.2c-4.8-4.7-12.5-4.7-17.2,0L57.6,111.8C52.9,116.5,52.9,124.3,57.6,129z"/>
              </svg>
            </span>
            <span class="pagefield"><input id="pagefieldId" ref="pagefield" class="pagenr-field"  @click="clearField"  v-model="pagenr" placeholder="" v-on:keydown.enter="evalPage"> </span>
            <span class="page-next" @click="goToNextPage()">
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 240.8 240.8" style="enable-background:new 0 0 240.8 240.8;" xml:space="preserve"><path id="Chevron_Right" d="M183.2,111.8L74.9,3.6c-4.8-4.7-12.5-4.7-17.2,0c-4.8,4.7-4.8,12.4,0,17.2l99.7,99.7l-99.7,99.7
                c-4.8,4.7-4.8,12.4,0,17.2c4.8,4.7,12.5,4.7,17.2,0L183.2,129C187.9,124.3,187.9,116.5,183.2,111.8z"/>
              </svg>
            </span>
            <span class="arrow text-next" @click="goToNextText()">→</span>
        </div>
    </div>
    <Burger navType="Book" />
    <BookMenu ref="bookmenu"/>
    <keep-alive>
      <BookContainer ref="bookcontainer"  :callFromRegister="callFromRegister" />
    </keep-alive>
  </div>
</template>



<script>

//import History from '@/components/History.vue'
import Burger from '@/components/Burger.vue'
import BookMenu from '@/components/BookMenu.vue'
import BookContainer from '@/components/BookContainer.vue'
import axios from 'axios'
//import {historyLink, loadHandler, jumpToBookSection, loadBook, lazyload} from "@/components/Scripts/bookClickEventHandler"
import {loadHandler, setPageNr} from "@/components/Scripts/bookClickEventHandler"


export default {
  name: 'BookText',
  components: {
    Burger,
    BookMenu,
    BookContainer
    //RegisterContainer
  },
  data: function() {
    return {
      showHistory: false,
      component:"BookContainer",
      callFromRegister: false,
      showNavArrowBox: false,
      pagenr: this.$store.state.showPage
    }
  },
computed: {
    getVolume() {
        let vol = ""
        if (this.$store.state.activeTexts.actBookVolume !="" ) { 
            vol = " / Band  " + this.$store.state.activeTexts.actBookVolume
        }

        return vol;
    }
},  
  methods: {
     //historyLink, loadHandler,jumpToBookSection, loadBook, lazyload,

     loadHandler, setPageNr /*,
     setPage(pagenr){
        const event = new Event('keydown', {
            bubbles: false,
            cancelable: true})            
        this.pagenr = pagenr
        this.$refs.pagefield.dispatchEvent(event)        
     }*/,

  scrollToAnchor (origin) {

    // if this is the fist time!    
    if(this.$store.state.activeTexts.actBookVolume ==""){
        // get path mame
        let pathArray = window.location.pathname.split('/');
        // get volume
        let volume = pathArray[2]  
         
        if (!['1', '2', '3', '4', '5'].includes(volume)){
            volume = 0
            const baseURI = '/';           
            axios.get(baseURI + "book_start.html")
              .then((result) => {
                  // close MainNav if open
                  this.$store.commit('toggleMainNavState', false )
                  this.$store.commit('updateBooktext', result.data)
              })              
        }else {
          // check if there is a target given
          let target = ""
          if(window.location.hash) {            
              target = window.location.hash.substring(1)
          }
          loadHandler(event, {volume: volume, target: target, setFlag: true})
      }
        
    }


/* Scheint nicht mehr nötig mit neuem routing 
    this.$nextTick(() => {
      if(this.$route.hash) {
 console.log("here it is !!!!!!!!!") 
   
        const $el = document.querySelector(this.$route.hash)
        if($el != null){
            $el && window.scrollTo(0, $el.offsetTop);
            let page =  $el.closest("[data-n]") 
        }
      }
    });	
    
 */   

  },

    clearField: function(e) {
        this.$refs.pagefield.value = ""
    },

    showHistoryBox: function(e) {
      e.target.parentNode.classList.toggle("open")
      this.showHistory = ! this.showHistory

    },
    gotoanchor() {
        this.$router.push({ name: 'text', hash: '#ziel-para-6' })
    },

    goToPage: function(e) {
        alert("sdf")
      if (e.keyCode === 13) {        
        this.evalPage( this.pagenr )
      }
    },
    evalPage() {        
        const volume = this.$store.state.activeTexts.actBookVolume
        const pageTarget = "page-" + volume +"-"+this.pagenr    
        const element = document.getElementById(pageTarget);

       if(element == null) {return;}
        // handle menu
        let menuSection =  element.closest("[data-toc]") 
 
        if (menuSection){            
          const menuSectionId = menuSection.closest("[data-toc]").getAttribute('id')
          this.$store.commit('updateActiveTexts', { volume: menuSectionId.substring(0,1) , section: menuSectionId, target: menuSectionId, type: 'book'})
          this.openMenu(menuSectionId)

        }
        if (element) {
          this.$refs.bookcontainer.$refs.textcontainer.style.opacity = 0
          setTimeout(() => {
            element.scrollIntoView(true)
            window.scrollBy(0, -100)            
            this.setPageNr(element)            
            this.$refs.bookcontainer.$refs.textcontainer.style.opacity = 1
          }, 500) 
        }        
    },
    goToPreviousPage () {
      if (this.pagenr > 1) {
        this.pagenr--
        this.evalPage(this.pagenr )
      }

    },
    goToNextPage() {
      this.pagenr++
      this.evalPage(/*this.pagenr*/ )
    },
    goToPreviousText ()  {
      const index = this.$store.state.navStates.bookNavHrefArray.indexOf(this.$store.state.activeTexts.actBookTarget)
      let navItems = []
      let tempel
      if (index > 0 ){ 
        const item =   this.$store.state.navStates.bookNavHrefArray[index -1]
        loadHandler(event, {name: item, target: item, volume: item.substring(0,1)} )  
       
          this.$router.push({ 
              name: 'text', 
              hash: "#"+item,
              params: {vol: item.substring(0,1)} })  
              
             window.history.replaceState({}, "myRState", "/text/"+item.substring(0,1)+"#"+item  );
              

             
        navItems = item.split("-")
        tempel = document.getElementById(item)
        this.openMenu(item)
      }
      let tmpPage = tempel.querySelector(".pb-druck")
      let tmpPageNr
      if(tmpPage) {
          tmpPageNr = tmpPage.id.split("-")[2] 
          this.pagenr = tmpPageNr
      }

    },
    goToNextText ()  {


      const index = this.$store.state.navStates.bookNavHrefArray.indexOf(this.$store.state.activeTexts.actBookTarget)

      let navItems = []
      let tempel
      
      if (index + 1 <  this.$store.state.navStates.bookNavHrefArray.length){
        const item =   this.$store.state.navStates.bookNavHrefArray[index +1]
    ///    loadHandler(event,  {name: item, target: item, volume: item.substring(0,1)}) 
        
        
        this.$router.push({ 
            name: 'text', 
            hash: "#"+item,
            params: {vol: item.substring(0,1)} })

            window.history.replaceState({}, "myRState", "/text/"+item.substring(0,1)+"#"+item  );

 
        navItems = item.split("-")
        tempel = document.getElementById(item)
        this.openMenu(item)
      }

      if(tempel) {
        let tmpPage = tempel.querySelector(".pb-druck")
        let tmpPageNr
        if(tmpPage) {
            tmpPageNr = tmpPage.id.split("-")[2] 
        this.pagenr = tmpPageNr
        }
        

        // Handle Menu opending
        if (typeof navItems[1] !='undefined'){
          this.$refs.bookmenu.level0[navItems[0]-1].isShow=true   
        }
        if (typeof navItems[2] !='undefined'){
          this.$refs.bookmenu.level0[navItems[0]-1].level1[navItems[1]-1].isShow=true   
        }
        if (typeof navItems[3] !='undefined'){
          this.$refs.bookmenu.level0[navItems[0]-1].level1[navItems[1]-1].level2[navItems[2]-1].isShow=true   
        } 
        if (typeof navItems[4] !='undefined'){
          this.$refs.bookmenu.level0[navItems[0]-1].level1[navItems[1]-1].level2[navItems[2]-1].level3[navItems[3]-1].isShow=true   
        }   
      }         
      
    },

    openMenu: function(menuSection){
      this.$nextTick(() => {              
          const navItems = menuSection.split("-")
          // Handle Menu opending
          if (typeof navItems[1] !='undefined'){
            this.$refs.bookmenu.level0[navItems[0]-1].isShow=true   
          }
          if (typeof navItems[2] !='undefined'){
            this.$refs.bookmenu.level0[navItems[0]-1].level1[navItems[1]-1].isShow=true   
          }
          if (typeof navItems[3] !='undefined'){
            this.$refs.bookmenu.level0[navItems[0]-1].level1[navItems[1]-1].level2[navItems[2]-1].isShow=true   
          } 
          if (typeof navItems[4] !='undefined'){
            this.$refs.bookmenu.level0[navItems[0]-1].level1[navItems[1]-1].level2[navItems[2]-1].level3[navItems[3]-1].isShow=true   
          } 
      })
    },

  }, 

  watch: { 
      $route(to, from) { 
          if (to.name.includes("text") ){ 
            this.$refs.bookcontainer.$refs.textcontainer.style.opacity = 0 
       
            this.$nextTick(() => {
              const volume = to.params.vol
              loadHandler(event, {volume: volume, target: to.hash.substring(1)})
            })
          }
      }
  },
  mounted() {
      this.$store.commit('updateBreadcrumb',  "Text")
      this.scrollToAnchor("updated")          
  },
  updated () {
    this.scrollToAnchor("updated")
  }
}

</script>

<style lang="scss">
 // @import  '../assets/nav8.css';

//@import "@/assets/css/_typo.scss";
//@import "@/assets/css/_variables.scss";
//@import "@/assets/css/textcommons.scss";

//@import url('https://use.typekit.net/vll6tjb.css');

</style>
